import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ModernIcons } from './ModernIcons';
import './Navigation.modern.css';

const Navigation: React.FC = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Главная', icon: ModernIcons.Home },
    { path: '/planner', label: 'Планирование', icon: ModernIcons.Calendar },
    { path: '/health', label: 'Здоровье', icon: ModernIcons.Heart },
    { path: '/self-development', label: 'Развитие', icon: ModernIcons.Sparkles },
    { path: '/wellness', label: 'Благополучие', icon: ModernIcons.Leaf },
    { path: '/community', label: 'Рядом Club', icon: ModernIcons.User },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="navigation">
        <div className="nav-container">
          <div className="nav-header">
            <Link to="/" className="nav-logo">
              <span className="logo-icon">🌸</span>
              <span className="logo-text">Рядом</span>
            </Link>
            <button 
              className="mobile-menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Открыть меню"
            >
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
          
          <ul className={`nav-list ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            {navItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span className="nav-icon"><item.icon size={18} /></span>
                  <span className="nav-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
      
      {/* Breadcrumbs */}
      <div className="breadcrumbs">
        <div className="breadcrumbs-container">
          <Link to="/" className="breadcrumb-home">
            <span className="breadcrumb-icon">🏠</span>
            <span className="breadcrumb-text">Главная</span>
          </Link>
          {location.pathname !== '/' && (
            <>
              <span className="breadcrumb-separator">›</span>
              <span className="breadcrumb-current">
                {navItems.find(item => item.path === location.pathname)?.label || 'Страница'}
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Navigation;
